/*********************** Custom JS for Boost AI Search & Discovery  ************************/
const customize = {
   updateProductItemGrid: (componentRegistry) => {
      componentRegistry.useComponentPlugin('ProductItem', {
         name: 'Add extra information',
         enabled: true,
         apply: () => ({
            afterRender(element) {
               try {
                  // Start customization--------------------------------------------
                  let productData = element.getParams().props.product;
                  let productId = productData.id;
                  if (productData?.split_product) {
                     productId = productData.variant_id;
                  }
                  let productItem = document.querySelector('[data-product-id="' + productId + '"]');
                  if (productItem) {
                     /* use pure js here */
                     /* Example - Add percent sale info */
                    const InventoryStatus = productData.variants.reduce(function(sum, curr) { return sum + curr.inventory_quantity;}, 0);

                     if (InventoryStatus == 0) {
                        const outOfStock = `<span class="boost-sd-out-of-stock" style="color:rgb(242, 145, 0)">On request</span>`;
                        if (!productItem.querySelector('.boost-sd-out-of-stock')) {
                           productItem.querySelector('.boost-sd__inventory-status').innerHTML = outOfStock;
                        }
                     }
                      /* End example */
                  }
                  // End-------------------------------------------------------------
               } catch (e) {
                  console.warn(e);
               }
            }
         }),
      });
   }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateProductItemGrid]);

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
   (componentRegistry) => {
      componentRegistry.useComponentPlugin('FormatCurrency', {
         name: 'Customize price format',
         apply: () => ({
            afterRender: (element) => {
               try {
                  // Start customization--------------------------------------------
                   const formatMoneyHelper = element.getHelpers().formatMoney;
                   if (!formatMoneyHelper) return;
                   const value = element.getParams().props.value; // Get price
                   const customValue = formatMoneyHelper(Number(value), window.boostSDAppConfig?.shop?.money_format, true);

                   if (customValue && element.getRootElm() && element.getRootElm().querySelector('.boost-sd__format-currency span')) {
                             element.getRootElm().querySelector('.boost-sd__format-currency span').innerHTML = customValue.replace(/,/g,'\'');
                   }
                  // End-------------------------------------------------------------
               } catch (e) {
                  console.warn(e);
               }
            },
         }),
      });
   }
]);